import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { Event, NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LifecycleManager } from '../../../../../modules/src/lib/core/managers/lifecycle.manager';
import { FloatingMenuItem } from '@magieno/angular-floating-button';
import { FloatingMenuItemEnum } from '../../enums/floating-menu-item.enum';
import { getFeedback } from '@sentry/angular';

import { EventStore } from '../../stores/event.store';


@Component({
  selector: 'app-layout',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  standalone: false,
})
export class RootComponent implements OnInit {

  menuItems: FloatingMenuItem[] = [
    {
      label: 'Signaler un bogue',
      id: FloatingMenuItemEnum.ReportBug,
      iconClass: 'far fa-bug',
    },
    {
      label: 'Clavardage en ligne',
      id: FloatingMenuItemEnum.Chat,
      iconClass: 'far fa-comments',
    },
    {
      label: 'Calculs rapides',
      id: FloatingMenuItemEnum.QuickCalculations,
      iconClass: 'far fa-calculator-alt',
    },
  ];

  constructor(
    private router: Router,
    private readonly lifecycleManager: LifecycleManager,
    private readonly eventStore: EventStore,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: Event) => {

        // Hubspot code tracking to track every page visit of our customers.
        const _hsq = window['_hsq'] = window['_hsq'] || [];
        _hsq.push(['setPath', { path: (event as RouterEvent).url }]);
        _hsq.push(['trackPageView']);
      });


  }

  ngOnInit(): void {
    this.lifecycleManager.firstLoad();
  }

  async menuItemClicked(menuItem: FloatingMenuItem) {
    switch (menuItem.id) {
      case FloatingMenuItemEnum.Chat: {
        await this.document.defaultView?.['HubSpotConversations']?.widget?.load({ widgetOpen: true });
        break;
      }
      case FloatingMenuItemEnum.QuickCalculations: {
        await this.eventStore.openQuickCalculation();
        break;
      }
      case FloatingMenuItemEnum.ReportBug: {
        const feedback = getFeedback();
        const form = await feedback?.createForm();
        form.appendToDom();
        form.open();
        break;
      }
    }
  }

}
